// extracted by mini-css-extract-plugin
export default {"searchInput":"input_searchInput__MziN9"};